import { Component } from 'react';
import { GroupControl } from '../../../../GroupField';
import GeoLocationField from '../Field';
import GeoLocationControl from '../Control';

export default class GeoLocationGroupField extends Component {
  render() {
    return (
      <GeoLocationField
        {...this.props}
        component={GroupControl}
        FormControl={GeoLocationControl}
      />
    );
  }
}
